'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function DEFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-3y10sj8mf", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-3y10sj8mf)" }, /* @__PURE__ */ React.createElement("path", { fill: "#ffd018", d: "M0 16h32v6a2 2 0 01-2 2H2a2 2 0 01-2-2z" }), /* @__PURE__ */ React.createElement("path", { fill: "#e31d1c", d: "M0 8h32v8H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#272727", d: "M2 0h28a2 2 0 012 2v6H0V2a2 2 0 012-2z" })))
  );
}

export { DEFlag };
//# sourceMappingURL=DE.mjs.map
